// extracted by mini-css-extract-plugin
module.exports = {"workaround":"CommunicareWorkaround_workaround__hnTpn"};